import { render, staticRenderFns } from "./Detail.daily.vue?vue&type=template&id=6501af45&"
import script from "./Detail.daily.vue?vue&type=script&lang=js&"
export * from "./Detail.daily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports